/* Doppel Ducks PDP: variant selection, garment recolor, ajax add-to-cart */
document.addEventListener('DOMContentLoaded', function(){
  var dataEl = document.getElementById('ddVariants');
  if(!dataEl) return;
  var VARIANTS = JSON.parse(dataEl.textContent);
  var GARMENT = window.DD_GARMENT || 'T-Shirt';
  /* Crew SVG recolor fallback (tees use real flatlay photos via DD_FLATLAYS) */
  var FILLS = {
    'White':    { fill:'#FFFFFF', rib:'#ECE8DC', wr:'#161514' },
    'Black':    { fill:'#26231F', rib:'#3B3831', wr:'#4a463f' },
    'Butter':   { fill:'#F4E09E', rib:'#E7CF82', wr:'#161514' },
    'Ivory':    { fill:'#E8DFD4', rib:'#DCD2C4', wr:'#161514' },
    'Pepper':   { fill:'#595653', rib:'#4C4946', wr:'#8a8781' },
    'Espresso': { fill:'#7D6459', rib:'#6E564C', wr:'#a8918a' },
    'Hemp':     { fill:'#6B6A52', rib:'#5D5C46', wr:'#9a9880' }
  };
  var FLATLAYS = window.DD_FLATLAYS || {};
  var sel = { c: null, s: null };
  var first = VARIANTS[0];
  var selSwatch = document.querySelector('.swatch.sel');
  var selSize = document.querySelector('#sizePills .pill.sel');
  sel.c = selSwatch ? selSwatch.dataset.color : first.c;
  sel.s = selSize ? selSize.dataset.size : first.s;

  function current(){
    return VARIANTS.find(function(v){ return v.c === sel.c && v.s === sel.s; }) || first;
  }
  function render(){
    var v = current();
    ['pdpPrice','atcPrice','stickyPrice'].forEach(function(id){
      var el = document.getElementById(id); if(el) el.textContent = v.price;
    });
    var cn = document.getElementById('colorName'); if(cn) cn.textContent = sel.c;
    var spec = document.getElementById('stickySpec');
    if(spec) spec.textContent = GARMENT + ' · ' + sel.c + ' · ' + sel.s;
    var g = document.getElementById('pdpGarment');
    var f = FILLS[sel.c] || FILLS.White;
    if(g){ g.style.setProperty('--g-fill', f.fill); g.style.setProperty('--g-rib', f.rib); g.style.setProperty('--g-wr', f.wr); }
    var blank = document.getElementById('pdpBlank');
    if(blank && FLATLAYS[sel.c]){ blank.src = FLATLAYS[sel.c]; }
    var tb = document.getElementById('pdpThumbBlank');
    if(tb && FLATLAYS[sel.c]){ tb.src = FLATLAYS[sel.c]; }
    var atc = document.getElementById('ddAtcBtn');
    if(atc) atc.disabled = !v.avail;
  }

  document.querySelectorAll('.swatch').forEach(function(sw){
    sw.addEventListener('click', function(){
      document.querySelectorAll('.swatch').forEach(function(x){ x.classList.remove('sel'); });
      sw.classList.add('sel'); sel.c = sw.dataset.color; render();
    });
  });
  document.querySelectorAll('#sizePills .pill').forEach(function(p){
    p.addEventListener('click', function(){
      document.querySelectorAll('#sizePills .pill').forEach(function(x){ x.classList.remove('sel'); });
      p.classList.add('sel'); sel.s = p.dataset.size; render();
    });
  });

  /* gallery view toggle */
  document.querySelectorAll('[data-view-btn]').forEach(function(t){
    t.addEventListener('click', function(){
      document.getElementById('pdpMain').dataset.view = t.dataset.viewBtn;
      document.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('sel'); });
      t.classList.add('sel');
    });
  });

  /* ajax add to cart */
  function addToCart(){
    var v = current();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: v.id, quantity: 1 })
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return fetch('/cart.js');
    }).then(function(r){ return r.json(); }).then(function(cart){
      var cc = document.getElementById('cartCount');
      if(cc) cc.textContent = cart.item_count;
      var name = (document.getElementById('ddAtcBtn') || {}).dataset ? document.getElementById('ddAtcBtn').dataset.toastName : '';
      toast(name + ' (' + GARMENT + ' · ' + sel.c + ' · ' + sel.s + ') added to pond ✓');
    }).catch(function(){ toast('Hmm, that didn’t work — try again 🦆'); });
  }
  var b1 = document.getElementById('ddAtcBtn'); if(b1) b1.addEventListener('click', addToCart);
  var b2 = document.getElementById('ddAtcBtnSticky'); if(b2) b2.addEventListener('click', addToCart);

  /* sticky bar */
  window.addEventListener('scroll', function(){
    var s = document.getElementById('stickyAtc');
    if(s) s.classList.toggle('show', window.scrollY > 520);
  }, { passive: true });

  render();

  /* preload the other flatlay colors so swatch switching is instant */
  window.addEventListener('load', function(){
    Object.keys(FLATLAYS).forEach(function(c){
      if(c !== sel.c){ var i = new Image(); i.src = FLATLAYS[c]; }
    });
  });
});
